/* mes-gallery-jump.js · V9.28.301 (+ V9.28.303: the button takes the brand blue, "Photo button colour", and fades through
   black while its text changes, so a new label is noticed; Shrey 27 Oct) (Shrey 27 Oct 2026): a gallery photo can carry a button that jumps to a section of the page.
   Universal: any product page using the main product section. Edited in the theme editor, no code:
     Product page section > "Photo buttons" (gallery_jumps), one rule per line:
       words in the photo's alt text or file name | button text | section id (the part after "__" in the section's id)
     e.g.  scratch test | Scratch test it now | tw_scratch
   Photos meant for every colour get an alt text starting "Common All" (e.g. "Common All Tungsten scratch test").
   With the 3D viewer on the page, its "View in 3D" pill is reused: on a matching photo (and with the 3D closed) it shows
   the rule's text and jumps instead. Without it, a pill of the same look appears only on matching photos.
   Phones: a section held in the "Why" tabs gets its tab opened first. Follows the carousel's own scroll (rAF-throttled). */
(function () {
  'use strict';
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function rules(txt) {
    return String(txt || '').split(/\n/).map(function (l) {
      var p = l.split('|').map(function (x) { return x.trim(); });
      return p.length >= 3 && p[0] && p[1] && p[2] ? { m: p[0].toLowerCase(), t: p[1], id: p[2].replace(/^#/, '') } : null;
    }).filter(Boolean);
  }

  function jumpTo(id) {
    var sec = document.getElementById(id) || document.querySelector('[id$="__' + id + '"]');
    if (!sec) return;
    if (sec.hidden && sec.id) { var tab = document.querySelector('[role="tab"][aria-controls="' + sec.id + '"]'); if (tab) tab.click(); }
    function want() {
      var top = sec.getBoundingClientRect().top + window.pageYOffset;
      var wt = sec.closest('[data-wt]');
      if (wt) { var bar = wt.querySelector('.mes-wt__bar'); top -= (parseFloat(getComputedStyle(wt).getPropertyValue('--wt-top')) || 78) + (bar ? bar.offsetHeight : 0) + 8; }
      else { top -= 90; }
      return Math.max(0, top);
    }
    requestAnimationFrame(function () { window.scrollTo({ top: want(), behavior: RM.matches ? 'auto' : 'smooth' }); });
    /* sections above load their images while the page scrolls and grow, so the target moves: re-measure and finish
       (OBSERVED desktop 27 Oct: landed ~1,500px short of the price section) */
    [700, 1400].forEach(function (ms) {
      setTimeout(function () { var t = want(); if (Math.abs(window.pageYOffset - t) > 40) window.scrollTo({ top: t, behavior: 'auto' }); }, ms);
    });
  }

  function init(gal) {
    if (gal._mesGj) return; gal._mesGj = true;
    var R = rules(gal.getAttribute('data-gallery-jumps'));
    if (!R.length) return;
    var list = gal.querySelector('.product-gallery__media-list');
    if (!list) return;

    /* the 3D pill, when the 3D section moved it into this gallery; else our own */
    var r3dRoot = document.querySelector('[data-mes-r3d]');
    var pill = document.querySelector('[data-r3d-pill]');
    var own = false, txt, onLabel = '';
    if (pill && pill.parentElement && (pill.parentElement.contains(gal) || gal.contains(pill))) {
      txt = pill.querySelector('[data-r3d-pill-t]') || pill;
      onLabel = (r3dRoot && r3dRoot.getAttribute('data-l-on')) || txt.textContent;
    } else {
      own = true;
      pill = document.createElement('button'); pill.type = 'button'; pill.className = 'mes-gj-pill'; pill.hidden = true;
      txt = pill; gal.appendChild(pill);
    }
    var active = null, raf = 0, swapT = 0, want = null;
    pill.classList.add('mes-gj-c');
    pill.style.setProperty('--gj-bg', gal.getAttribute('data-gallery-jump-color') || '#5d8bd7');
    /* new text: the button dips to black, the text is swapped at the darkest point, then it comes back to blue */
    function setText(t) {
      if (RM.matches) { txt.textContent = t; return; }
      want = t;
      if (swapT) return; /* a swap is running: it picks up the newest text at its midpoint */
      if (txt.textContent === t) return;
      pill.classList.remove('is-swap'); void pill.offsetWidth; pill.classList.add('is-swap');
      swapT = setTimeout(function () {
        swapT = 0; txt.textContent = want;
        setTimeout(function () { pill.classList.remove('is-swap'); }, 360);
      }, 240);
    }
    function is3dOpen() { return !own && pill.getAttribute('aria-pressed') === 'true'; }
    function currentSlide() {
      var hr = list.getBoundingClientRect(), best = null, bestA = 0;
      var s = list.querySelectorAll('.product-gallery__media');
      for (var i = 0; i < s.length; i++) {
        if (s[i].hidden || s[i].style.display === 'none') continue;
        var r = s[i].getBoundingClientRect();
        var a = Math.max(0, Math.min(r.right, hr.right) - Math.max(r.left, hr.left)) * Math.max(0, Math.min(r.bottom, hr.bottom) - Math.max(r.top, hr.top));
        if (a > bestA) { bestA = a; best = s[i]; }
      }
      return best;
    }
    function keyOf(m) {
      if (!m) return '';
      var im = m.querySelector('img');
      return ((m.getAttribute('data-media-alt') || '') + ' ' + (im ? (im.currentSrc || im.src || '') : '')).toLowerCase();
    }
    function sync() {
      raf = 0;
      if (is3dOpen()) { active = null; return; }
      var k = keyOf(currentSlide()), hit = null;
      for (var i = 0; i < R.length && !hit; i++) if (k.indexOf(R[i].m) !== -1) hit = R[i];
      active = hit;
      if (own) { if (hit && pill.hidden) { txt.textContent = hit.t; pill.hidden = false; } else if (!hit) pill.hidden = true; else setText(hit.t); }
      else { setText(hit ? hit.t : onLabel); pill.classList.toggle('is-jump', !!hit); }
    }
    function later() { if (!raf) raf = requestAnimationFrame(sync); }
    list.addEventListener('scroll', later, { passive: true });
    gal.addEventListener('carousel:settle', later);
    gal.addEventListener('carousel:change', later);
    document.addEventListener('variant:change', function () { setTimeout(later, 120); });
    if (!own && window.MutationObserver) new MutationObserver(function () { later(); }).observe(pill, { attributes: true, attributeFilter: ['aria-pressed'] });
    /* capture phase, so on a matching photo the 3D pill's own handler never runs */
    pill.addEventListener('click', function (e) {
      if (!active || is3dOpen()) return;
      e.preventDefault(); e.stopImmediatePropagation(); jumpTo(active.id);
    }, true);
    setTimeout(later, 300);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('product-gallery[data-gallery-jumps]'), init); }
  /* after load: the 3D section moves its pill into the gallery on DOMContentLoaded, and we reuse that pill */
  if (document.readyState === 'complete') setTimeout(boot, 0); else window.addEventListener('load', function () { setTimeout(boot, 0); });
})();
